export enum ChainType {
  SOL = 'SOL',
  XLM = 'XLM',
  POLY = 'POLY',
  TRX = 'TRX',
  TRON = 'TRON',
  MATIC = 'MATIC',
  BASE = 'BASE',
  ETH = 'ETH',
}
